import { render, staticRenderFns } from "./onebox-dcm.vue?vue&type=template&id=b46b7008&"
import script from "./onebox-dcm.vue?vue&type=script&lang=js&"
export * from "./onebox-dcm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports